import React from "react";
import Popup from "./Popup";
import "../assets/scss/components/uploading-popup-animation.scss"
import {LoadingIcon} from "../assets/icons/Icons";

const UploadingPopupAnimation = (props) => {
    return (
        <Popup withClose onClose={props.onClose}>
            <div className="uploading-popup-animation">
                <div className="row">
                    <div className="col-xs-3">
                        <div className="uploading-popup-animation__loader-icon">
                            <LoadingIcon/>
                        </div>
                    </div>
                    <div className="col-xs-9">
                        <h4 className="uploading-popup-animation__title">{props.title}</h4>
                        <p className="uploading-popup-animation__description">{props.description}</p>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default UploadingPopupAnimation;


